import { render, staticRenderFns } from "./GroupGanttChart.vue?vue&type=template&id=f9254328&"
import script from "./GroupGanttChart.vue?vue&type=script&lang=ts&"
export * from "./GroupGanttChart.vue?vue&type=script&lang=ts&"
import style0 from "./GroupGanttChart.vue?vue&type=style&index=0&id=f9254328&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports